export default "__VITE_ASSET__DP_6rbkf__"